import { Icon } from 'components/common/Icon';
import React from 'react';
import styled from 'styled-components';
import { Text } from 'styles';

export function MainSpeciality({ navigate, list }) {
  return (
    <Container onClick={() => navigate('/technology')}>
      {list.map((item, index) => (
        <div key={`item_${index}`}>
          <IconBox>
            <Icon
              name={item.name}
              $width={item.width}
              $tWidth={item.tWidth}
              $mWidth={item.mWidth}
              $height={108}
              $tHeight={81}
              $mHeight={59}
            />
          </IconBox>
          <TextBox>
            <Text $type="b5" $mType="b8" $whiteSpace="pre">
              {item.subject}
            </Text>
          </TextBox>
        </div>
      ))}
    </Container>
  );
}

const Container = styled.div`
  max-width: 1432px;
  padding: 24px 0;
  margin: 0 auto;
  display: flex;

  & > div {
    cursor: pointer;
    position: relative;
    z-index: 10;
    flex: 3.33;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    & > div:nth-child(2) {
      min-height: 116px;
      max-width: 240px;
      justify-content: unset;
    }

    &:hover {
      & > div:nth-child(1) {
        transform: scale(1.125);
      }
    }
  }

  @media ${({ theme }) => theme.device.tablet} {
    & > div {
      position: relative;
      z-index: 10;

      & > div:nth-child(1) {
        transition: all 0.3s cubic-bezier(0, 0, 0.2, 1);
      }
      & > div:nth-child(2) {
        max-width: 180px;
      }
    }
  }

  @media ${({ theme }) => theme.device.mobile} {
    flex-direction: column;
    gap: 16px;
    padding: 24px 0 0;

    & > div > div:nth-child(2) {
      min-height: 74px;
    }
  }
`;

const IconBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(23, 23, 23, 0.12);
  align-items: center;
  border-radius: 50%;
  max-width: 240px;
  width: 100%;
  aspect-ratio: 1/1;
  margin-bottom: 16px;
  transition: all 0.3s cubic-bezier(0, 0, 0.2, 1);

  @media ${({ theme }) => theme.device.tablet} {
    max-width: 180px;
  }
  @media ${({ theme }) => theme.device.mobile} {
    max-width: 148px;
  }
`;

const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;
  padding: 0 16px;
`;
